import React, { useEffect, useState, useMemo, useRef } from "react";
import { formatNumberWithCommas, formatDate } from '../../../common/utility'

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  InputGroup
} from "reactstrap";

import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from "components/Common/TableContainerV1";

import { getNewProductReport } from "../../../helpers/UAM/report.helper";
import * as XLSX from 'xlsx';
import { formatDateTime } from "common/utility";

const NewProductInquiryReport = props => {

  //meta title
  document.title = "Product Inquiry Reports | DMS";

  const [productInquiryData, setProductInquiryData] = useState([])
  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("inquiryNumber");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [filters, setFilters] = useState(null);
  const [sortingOptions, setSortingOptions] = useState({
    column: "", isAsc: false, optionalColumn: [],
  });

  const flatpickrRef = useRef(null);

  // Customber Column
  const columns = useMemo(
    () => [

      {
        Header: 'Inquiry Number',
        accessor: 'inquiryNumber',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Sub Inquiry Number',
        accessor: 'subinquiryNumber',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
          ;
        }
      },
      {
        Header: 'Dealer Name',
        accessor: 'entityName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Product Description',
        accessor: 'productDescription',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Expected Price Per Unit',
        accessor: 'price',
        filterable: true,
        alignRight: true,
        Cell: (cellProps) => (
          <div style={{ textAlign: 'right' }}>
            {formatNumberWithCommas(cellProps.value ? +cellProps.value : "")}
          </div>
        ),
      },
      {
        Header: 'Expected Delivery Date',
        accessor: 'deliveryDate',
        filterable: true,
        Cell: (cellProps) => {
          return formatDate(cellProps.value ? cellProps.value : "");

        }
      },
      {
        Header: 'Status',
        accessor: 'inquiryStatus',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },

    ],
    []
  );

  useEffect(() => {
    fetchProductInquiryReport({})
  }, [])

  const fetchProductInquiryReport = (data) => {
    getNewProductReport(data)
      .then((response) => {
        if (response.status && response.code == 200) {
          let resultWithFormatttedDate = response.data.data.map(item => {
            item.deliveryDate = formatDateTime(item.deliveryDate)
            return item
          })
          setProductInquiryData(resultWithFormatttedDate);
          const { totalItems, totalPages, currentPage } = response.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setProductInquiryData([])
        }
      })
      .catch((err) => { console.log(err) })
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus, filterType = filters) => {
    setPageSize(pageSize);
    setCurrentPage(page)
    fetchProductInquiryReport({ page, limit: pageSize, searchKey, columnName, sortingOrder, filterType })

  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  };

  const handleClearSearch = () => {
    setSearchValue("");
    setFilters(null)
    flatpickrRef.current.flatpickr.clear();
    handlePageChange(1, pageSize, "", 'inquiryNumber', 'desc', null);
  };

  const handleDateFilter = () => {
    handlePageChange(1, pageSize, searchValue, columnId, sortingOrderStatus, filters)
  }

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };

  const downloadExcel = () => {
    let dataWithModifiedCol = productInquiryData.map(report => {
      let newReport = {
        "Inquiry Number": report.inquiryNumber,
        "Sub Inquiry Number": report.subinquiryNumber,
        "Dealer Name": report.entityName,
        "Product Description": report.productDescription,
        "Expected Price Per Unit": report.price,
        "Expected Delivery Date": report.deliveryDate,
        "Status": report.inquiryStatus,
      }
      return newReport
    })
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
    // Add the sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, sheetData, 'NewProductInquiryReport');
    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'New_Product_Inquiry_Report.xlsx');
  };

  const customeFilterSection = (
    <div className="d-flex align-items-center justify-content-start">
      <InputGroup style={{ minWidth: '250px' }}>
        <Flatpickr
          ref={flatpickrRef}
          className="form-control"
          placeholder="Start Date - End Date"
          options={{
            mode: 'range',
            dateFormat: 'd-m-Y'
          }}
          value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
          onChange={handleDateChange}
        />
        <Button variant="primary"
          onClick={handleDateFilter}
          style={{ backgroundColor: "#344fa0", border: "none" }}>
          Go
        </Button>
      </InputGroup>
    </div>
  )

  const buttonSection = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={downloadExcel}
      >
        <i className="bx bx-archive-in me-1" />
        {'Download'}
      </Button>
    </div>
  );

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Reports" breadcrumbItem="New Product Inquiry Report" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={productInquiryData}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customFilterSection={customeFilterSection}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  searchHelperText="Search by Inquiry Number, Sub Inquiry Number, Dealer Name, Product Description"
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewProductInquiryReport;
